import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 通用混合
 * */
import { mapActions, mapState } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread({}, mapState('admin/layout', ['innerWidth'])), {}, {
    // 路由信息
    routerParams: function routerParams() {
      return this.$route.params;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions('admin/page', ['close'])), {}, {
    px2rem: function px2rem(px) {
      var dpi = this.innerWidth / 1920;
      return dpi * px;
    },
    // 返回上一页
    goBack: function goBack() {
      this.$router.go(-1);
    },
    // 关闭当前页面并返回
    navigatorBack: function navigatorBack() {
      var tagName = this.$route.fullPath;
      this.$router.go(-1);
      this.close({
        tagName: tagName
      });
    },
    // 关闭页面
    handleClickClose: function handleClickClose(tagName) {
      this.close({
        tagName: tagName
      });
    },
    // closeBack () {
    //     this.handleClickClose(this.$route.fullPath)
    // },
    // 全局通知
    sendMessage: function sendMessage(text) {
      var _this = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
      var isBackground = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return new Promise(function (resolve, reject) {
        _this.$Message[type]({
          background: isBackground,
          content: text
        });
        resolve();
      });
    }
  })
};